<p class="text" data-testid="message-text">
  <span>{{ messageText() }}</span>
  @if (link()) {
    <orbit-fa-icon [iconName]="openLinkIcon" iconSize="xs" />
  }
</p>
